export default __webpack_public_path__ + "static/media/icone-excluir.396ab8c4.svg";